import { AnyAction, createAsyncThunk, createSlice, ThunkDispatch } from '@reduxjs/toolkit';
import { IPointListItem } from '@App/types';
import { RootState } from '@App/store';

import pointListApi from '@App/services/pointList/pointListApi';
import { setActiveTab } from '@Features/pointsScreen/pointsScreenSlice';
import { pollingSucceeded, pollingFailed } from '@Features/errorHandler/polling/pollingErrorHandlerSlice';
import { eventsApi } from '@App/services/events/eventsApi';

import { pollingErrorHandlerSlice } from '@Features/errorHandler/polling/pollingErrorHandlerSlice';

export interface IPointListState {
  changeTimestamp: number; // Tohle trigeruje mount/unmout pooling kontejneru, tak aby se forsnul reload při znovu kliku (jinak se vysypal state)
  dataLoaded: boolean;
  isFetching: boolean;
  error: any;
  data: IPointListItem[];
}

const initialState: IPointListState = {
  changeTimestamp: 0,
  dataLoaded: false,
  isFetching: false,
  error: null,
  data: [],
};

export const getPointListDataAsync = createAsyncThunk(
  'pointList/fetchData',
  async (timeTableId: number, { dispatch, rejectWithValue, signal }) => {
    try {
      const response = await pointListApi.fetchPointListData(timeTableId, signal);

      const thunkDispatch = dispatch as ThunkDispatch<any, any, AnyAction>; // Nutno to přetypovat, TypeScript si s tím nějak
      thunkDispatch(eventsApi.util.updateQueryData('getEventsStatesPoints', '', draft => {
        draft[timeTableId] = response.eventState;
      }));

      dispatch(pollingSucceeded());

      return response.data;
    } catch (err) {
      dispatch(pollingFailed({ sectionName: 'PointList', error: err }));
      return rejectWithValue(err);
    }
  }
);

export const pointListSlice = createSlice({
  name: 'pointListSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPointListDataAsync.pending, state => {
        state.isFetching = true;
      })
      .addCase(getPointListDataAsync.fulfilled, (state, action) => {
        state.isFetching = false;
        state.dataLoaded = true;
        state.data = action.payload;
      })
      .addCase(getPointListDataAsync.rejected, (state, action) => {
        if (action.error.name !== 'AbortError') {
          state.isFetching = false;
          state.error = action.payload;
        }
      })
      .addCase(setActiveTab, (state, action) => { // Clear state
        if (action.payload.activeTab && action.payload.changed) {
          Object.assign(state, initialState);
        }
      })
      .addCase(eventsApi.internalActions.unsubscribeQueryResult, state => { // Clear state when moving to different screen
        Object.assign(state, initialState);
      })
      .addCase(pollingErrorHandlerSlice.actions.clearPollingErrors, (state) => {
        state.error = null;
      });
  }
});

export const selectIsFetching = (state: RootState) => state.commonPoints.isFetching;
export const selectError = (state: RootState) => state.commonPoints.error;
export const selectDataLoaded = (state: RootState) => state.commonPoints.dataLoaded;
export const selectData = (state: RootState) => state.commonPoints.data;
export const selectChangeTimestamp = (state: RootState) => state.commonPoints.changeTimestamp;

export default pointListSlice.reducer;